(function() {
    'use strict';

    angular
        .module('sgnmrApp')
        .controller('DocumentoDialogController', DocumentoDialogController);

    DocumentoDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Documento', 'Norma'];

    function DocumentoDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Documento, Norma) {
        var vm = this;

        vm.documento = entity;
        vm.clear = clear;
        vm.save = save;
        vm.normas = Norma.query();
        vm.uploadStart =uploadStart;
        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.documento.id !== null) {
                Documento.update(vm.documento, onSaveSuccess, onSaveError);
            } else {
                Documento.save(vm.documento, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('sgnmrApp:documentoUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }
        function uploadStart($flow){   
            //X-XSRF-TOKEN
            $flow.opts.headers =  {'X-XSRF-TOKEN' : getCSRF()};
        }
        function getCSRF() {
            var name = "XSRF-TOKEN=";
            var ca = document.cookie.split(';');
            for(var i=0; i<ca.length; i++) {
                var c = ca[i];
                while (c.charAt(0)==' ') c = c.substring(1);
                if (c.indexOf(name) != -1) return c.substring(name.length,c.length);
            }
            return "";
        }
    }
})();
